import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';

// Pages
import Welcome from './pages/Welcome';
import PasswordSetup from './pages/PasswordSetup';
import OTPLogin from './pages/OTPLogin';
import RequestSummary from './pages/RequestSummary';
import IDCapture from './pages/IDCapture';
import LivenessCheck from './pages/LivenessCheck';
import AddressVerification from './pages/AddressVerification';
import ReviewSubmit from './pages/ReviewSubmit';
import Completion from './pages/Completion';
import Profile from './pages/Profile';

const App = () => {
  const { initialized } = useAuthStore();

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="mobile-container bg-gray-50">
      <Routes>
        {/* Public verification flow */}
        <Route path="/invite/:token" element={<Welcome />} />
        <Route path="/verify/:token" element={<Welcome />} />
        <Route path="/password-setup" element={<PasswordSetup />} />
        <Route path="/login" element={<OTPLogin />} />
        <Route path="/summary" element={<RequestSummary />} />
        <Route path="/id-capture" element={<IDCapture />} />
        <Route path="/liveness" element={<LivenessCheck />} />
        <Route path="/address" element={<AddressVerification />} />
        <Route path="/review" element={<ReviewSubmit />} />
        <Route path="/complete" element={<Completion />} />

        {/* User profile */}
        <Route path="/profile" element={<Profile />} />

        {/* Default - show error for invalid routes */}
        <Route path="*" element={<Welcome />} />
      </Routes>
    </div>
  );
};

export default App;
